module.exports = __webpack_public_path__ + "static/img/bofangluyin.b109543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/bofangluyin.png
// module id = Hqcs
// module chunks = 24